import React, {useEffect, useState} from "react";
import {Field, Formik} from "formik";
import {BusinessFormCategoryValidation} from "../AddBusinessValidation";
import RadioField from "../../../../../components/radio-field/RadioField";
import {Button, InputField} from "../../../../../components";
import {SectionsProps, BusinessLevels} from 'models';

export const CategorySection: React.FC<SectionsProps> = ({
                                                             changeStep,
                                                             setNewBusinessInfo,
                                                             newBusinessInfo,
                                                             setSectionName
                                                         }) => {
    useEffect(() => {
        setSectionName('Business Category')
    }, [setSectionName]);

    const [categoryTypes] = useState([
        "Service Provider",
        "Business Service",
        "Professional Service",
        "Banking & Finance",
        "Wholesale/Distributor",
        "Retail Trader",
        "Food Processor",
        "Restaurant",
        "Construction",
        "Manufacturer",
        "Hospitality/Tourism",
        "Individual Membership",
        "Other",
    ])

    const [employeeOptions] = useState<Array<{ name: string, value: BusinessLevels }>>([
        {name: "1-5 Employees", value: BusinessLevels.MICRO_BUSINESS},
        {name: "6-20 Employees", value: BusinessLevels.SMALL_BUSINESS},
        {name: "20-100 Employees", value: BusinessLevels.MEDIUM_BUSINESS_ENTERPRISE},
        {name: "100+ Employees", value: BusinessLevels.ASSOCIATED_COMPANY},

    ])

    const [initialValues] = useState({
        category: newBusinessInfo?.category
    });

    const onSubmit = async (values: any, {setSubmitting}: any) => {
        setNewBusinessInfo && setNewBusinessInfo((prevInfo) => ({...prevInfo, category: values.category}))
        changeStep && changeStep("next")
        setSubmitting(false);
        console.log(values)
    }

    return (
        <div className={'add-business-section'}>
            <p className={'info'}><span>Note:</span> Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. </p>
            <Formik
                validateOnMount={false}
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={BusinessFormCategoryValidation}
                onSubmit={onSubmit}
            >
                {({handleSubmit, handleChange, values, handleBlur, errors, touched}) => (
                    <form onSubmit={handleSubmit}>
                        <div className={'add-business-section_input'}>
                            <div className={'add-business-section_input_radio'}>
                                <span>What is your business service type?</span>
                                <div>
                                    <RadioField
                                        id={'category.service_type.products'}
                                        name={'category.service_type'}
                                        text={'Products'}
                                        onchange={handleChange}
                                        value={'products'}
                                        checked={values.category.service_type === 'products'}
                                    />
                                    <RadioField
                                        id={'category.service_type.service'}
                                        name={'category.service_type'}
                                        text={'Service'}
                                        onchange={handleChange}
                                        value={'service'}
                                        checked={values.category.service_type === 'service'}
                                    />
                                </div>
                                <span id="--name__error" className="inputField_info_wrapper_message">
                                        {errors.category?.service_type && touched.category?.service_type && errors.category?.service_type}
                                </span>
                            </div>
                            <div className={'add-business-section_input_radio'}>
                                <span>Select Business Type:</span>
                                <Field
                                    name="category.category"
                                    id={"category.category"}
                                    as="select"
                                    onBlur={handleBlur}
                                    error={errors.category?.category && touched.category?.category}
                                    onChange={handleChange}
                                    value={values.category?.category}
                                    className={'signup__input inputField_container_input  '}
                                >
                                    <option value="" disabled hidden>Select Business Type</option>
                                    {
                                        categoryTypes.map((type, index) => (
                                            <option key={'c_c_i' + type + index} value={type}>{type}</option>
                                        ))
                                    }
                                </Field>
                                <span id="--name__error"
                                      className="inputField_info_wrapper_message">{errors.category?.category && touched.category?.category && errors.category?.category}
                            </span>
                            </div>

                            <InputField
                                id={"category.years"}
                                type="number"
                                classname="signup__input"
                                placeholder={"Number of Years in Operation"}
                                name="category.years"
                                onblur={handleBlur}
                                error={errors.category?.years && touched.category?.years}
                                onchange={handleChange}
                                message={errors.category?.years && touched.category?.years && errors.category?.years}
                                inputValue={values.category?.years}
                                label={'Number of Years in Operation'}
                            />
                            <InputField
                                id={"category.target_market"}
                                type="text"
                                classname="signup__input"
                                placeholder={"Target Market"}
                                name="category.target_market"
                                onblur={handleBlur}
                                error={errors.category?.target_market && touched.category?.target_market}
                                onchange={handleChange}
                                message={errors.category?.target_market && touched.category?.target_market && errors.category?.target_market}
                                inputValue={values.category?.target_market}
                                label={'Target Market'}
                            />

                            <div className={'add-business-section_input_radio'}>
                                <span>Number of Employees:</span>
                                <Field
                                    name="category.number_of_employees"
                                    id={"category.number_of_employees"}
                                    as="select"
                                    onBlur={handleBlur}
                                    error={errors.category?.number_of_employees && touched.category?.number_of_employees}
                                    onChange={handleChange}
                                    value={values.category?.number_of_employees}
                                    className={'signup__input inputField_container_input  '}
                                >
                                    <option value="" disabled hidden>Select Business Type</option>
                                    {
                                        employeeOptions.map(({name, value}, index) => (
                                            <option key={'c_n_o_e' + name + index}
                                                    value={value}> {name + "  (" + value + ")"}</option>
                                        ))
                                    }
                                </Field>
                                <span id="--name__error"
                                      className="inputField_info_wrapper_message">{errors.category?.number_of_employees && touched.category?.number_of_employees && errors.category?.number_of_employees}
                                </span>
                            </div>
                        </div>
                        <div className={'add-business-section_cta'}>
                            <Button type={"secondary"} onclick={() => changeStep && changeStep("prev")} text={"Prev"}/>
                            <Button type={"primary"} isSubmit={true} text={"Next"}/>
                        </div>
                    </form>
                )}
            </Formik>

        </div>
    );
};


